import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../templates/general';
import widgetsHelper from 'utils/getWidget.helper';
import {canUseDOM} from '../../../../../helpers/canUseDOM';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        const category = props.match.params && props.match.params.category;
        const mode =
            category === 'owners' || category === 'reports' || category === 'special-info'
                ? 'for-stakeholders'
                : category;

        this.state = {
            ui: this.uiStates.INITIAL,
            coordinates: {},
            where_by: ['path'],
            search_by: ['/about/general'],
            widgets: [],
            mode: mode || 'general'
        };

        this.widgetsHelper = widgetsHelper;
    }

    componentDidUpdate(prevProps) {
        const prevCategory = prevProps.match.params && prevProps.match.params.category;
        const nextCategory = this.props.match.params && this.props.match.params.category;
        if (prevCategory !== nextCategory) {
            const mode =
                nextCategory === 'owners' ||
                nextCategory === 'reports' ||
                nextCategory === 'special-info'
                    ? 'for-stakeholders'
                    : nextCategory;
            this.setState({mode: mode});
        }
        // Оновлюємо активну вкладку при переході через зовнішні посилання (футер, прямий URL)
    }

    componentWillMount() {
        if (canUseDOM) return;
        const {ssrData} = this.props;
        if (ssrData && ssrData.widgets && ssrData.widgets.length > 0) {
            this.setState({widgets: ssrData.widgets});
        }
    }

    componentDidMount() {
        this.widgetsHelper.getWidgets.call(this);
    }

    toggleMode = mode => {
        this.setState({mode: mode}, this.context.app.navigate(`/about/${mode}`));
    };

    static displayName = 'About';

    static contextTypes = {
        app: PropTypes.object,
        history: PropTypes.object
    };
}
